import { loader } from 'fetch-tree';
import {
    getContent,
    fetchContentForSection,
    getLastPageRead,
} from '../actions/content';
import {
    selectContent,
    selectContentForSection,
    selectLastPageRead,
} from '../selectors/content';

export function contentResource(id, options) {
    return {
        id: `content-${id}`,
        load() {
            return options.dispatch(getContent(id));
        },
        find() {
            return selectContent(options.rootState, id) || {};
        },
    };
}

export const contentLoader = loader({
    id: id => `content-${id}`,
    action: getContent,
    selector: selectContent,
});

export function sectionContentResource(options, section) {
    return {
        id: `/content/section/${section.id}`,
        load() {
            return options.dispatch(fetchContentForSection(section));
        },
        find() {
            return selectContentForSection(options.rootState, section);
        },
    };
}

export const sectionContentLoader = loader({
    id: section => `/content/section/${section.id}`,
    action: fetchContentForSection,
    selector: selectContentForSection,
});

export function lastPageResource(options, content) {

    if (content.media_type != 'text') {
        return () => null;
    }

    return {
        id: `last-page-read-${content.id}`,
        load() {
            return options.dispatch(getLastPageRead(content));
        },
        find() {
            return selectLastPageRead(options.rootState, content.id);
        },
    };
}

export const lastPageLoader = loader({
    id: content => (content ? `last-page-read-${content.id}` : ''),
    action: content => {
        if (content.media_type != 'text') {
            return dispatch => Promise.resolve(null);
        }
        return getLastPageRead(content);
    },
    selector: (state, content) => {
        if (!content || content.media_type != 'text') {
            return null;
        }

        selectLastPageRead(state, content.id);
    },
});



// WEBPACK FOOTER //
// ./src/resources/content.js